<div class="font-upload-container">
  <!-- Uploaded Fonts Section -->
  @if (uploadedFonts.length > 0) {
    <div class="uploaded-fonts">
      <h6>Uploaded Fonts</h6>
      @for (font of uploadedFonts; track font) {
        <div class="row font-item">
          <div class="col-sm-4 font-preview" [style.font-family]="font.fontFamily">
            {{ font.fontFamily }}
          </div>
          <div class="col-sm-4 font-details">
            <div class="font-name">{{ font.name }}</div>
          </div>
          <div class="col-sm-4">
            <button mat-icon-button color="warn" (click)="removeFont(font)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }

  <!-- Upload Form Section -->
  <div class="font-upload-form">
    <div class="file-input-container">
      <input
        type="file"
        id="fontFileInput"
        accept=".woff,.woff2,.ttf,.otf"
        (change)="onFileSelected($event)"
        [disabled]="isUploading"
        >
    </div>
    <button
      mat-raised-button
      color="primary"
      (click)="uploadFont()"
      [disabled]="!selectedFile || isUploading"
      >
      <mat-icon>upload</mat-icon>
      Upload Font
    </button>
  </div>
</div>
